import Vue from 'vue'
import App from './App.vue'
import VueLazyload from 'vue-lazyload'
import '@/assets/icons'

Vue.config.productionTip = false
Vue.use(VueLazyload)
// Vue.use(VueLazyload, {
//   preLoad: 1.3,
//   error: 'dist/error.png',
//   loading: 'dist/loading.gif',
//   attempt: 1
// })

new Vue({
  render: h => h(App),
}).$mount('#app')
